import React from "react";
import { FiArrowLeft, FiCalendar, FiLoader, FiRefreshCcw } from "react-icons/fi";
import { YEAR, DEFAULT_YEAR, formatDashboardTitle } from "../utils";

const DashboardHeader = ({
  title,
  selectedProcess,
  dashboard,
  navigate,
  location,
  selectedYear,
  setSelectedYear,
  loading,
  selectedMonth,
  setSelectedMonth,
  months,
  currentMonth,
  selectedMonthLabel
}) => {
  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-gradient-to-b from-slate-50 to-white p-4 shadow-sm">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">{title}</h1>
          <p className="mt-1 text-sm text-slate-500">
            Process: {formatDashboardTitle(selectedProcess)} | Status:{" "}
            {dashboard?.edaStatus || "Available"}
          </p>
        </div>

        <div className="flex items-center gap-2 self-start">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 shadow-sm transition hover:border-slate-300 hover:text-slate-800"
          >
            <FiArrowLeft className="h-4 w-4" />
            Back
          </button>
        </div>
      </div>

      {!location.state ? (
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-700">
          Open this page from the dashboard list so the selected dashboard
          context is available.
        </div>
      ) : (
        <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
          <div className="flex flex-col gap-3 md:flex-row md:items-center">
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-slate-400">Year</span>
              <select
                value={selectedYear}
                onChange={(event) =>
                  setSelectedYear(Number(event.target.value))
                }
                disabled={loading}
                className="min-w-[120px] rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 outline-none transition focus:border-blue-300 disabled:cursor-not-allowed disabled:bg-slate-50"
              >
                {YEAR.map((year) => (
                  <option key={year.value} value={year.value}>
                    {year.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-slate-400">
                Month
              </span>
              <select
                value={selectedMonth}
                onChange={(event) =>
                  setSelectedMonth(Number(event.target.value))
                }
                disabled={loading}
                className="min-w-[180px] rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 outline-none transition focus:border-blue-300 disabled:cursor-not-allowed disabled:bg-slate-50"
              >
                {months.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>

            <button
              type="button"
              onClick={() => {
                setSelectedMonth(currentMonth);
                setSelectedYear(DEFAULT_YEAR);
              }}
              disabled={loading}
              className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-500 shadow-sm transition hover:border-slate-300 hover:text-slate-700 disabled:cursor-not-allowed disabled:bg-slate-50"
            >
              <FiRefreshCcw className="h-3.5 w-3.5" />
              Reset to current month
            </button>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            {loading && (
              <div className="inline-flex items-center gap-2 rounded-full border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-medium text-blue-700">
                <FiLoader className="h-4 w-4 animate-spin" />
                Updating dashboard...
              </div>
            )}

            <div className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm font-medium text-emerald-700">
              <FiCalendar className="h-4 w-4" />
              Current period: {selectedMonthLabel} {selectedYear}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardHeader;
